import { ArrayUtils, Encoder, MGPOptional } from '@everyboard/lib';
import { Coord } from '../../jscaip/Coord';
import { GipfCapture } from '../../jscaip/GipfProjectHelper';
import { HexaDirection } from '../../jscaip/HexaDirection';
import { Move } from '../../jscaip/Move';
export class GipfPlacement {
    coord;
    direction;
    static encoder = Encoder.tuple([Coord.encoder, MGPOptional.getEncoder(HexaDirection.encoder)], (placement) => [placement.coord, placement.direction], (fields) => new GipfPlacement(fields[0], fields[1]));
    constructor(coord, direction) {
        this.coord = coord;
        this.direction = direction;
    }
    toString() {
        if (this.direction.isPresent()) {
            return this.coord.toString() + '@' + this.direction.get().toString();
        }
        else {
            return this.coord.toString();
        }
    }
    equals(other) {
        if (this.coord.equals(other.coord) === false) {
            return false;
        }
        return this.direction.equals(other.direction);
    }
}
export class GipfMove extends Move {
    placement;
    initialCaptures;
    finalCaptures;
    static encoder = Encoder.tuple([GipfPlacement.encoder, GipfCapture.listEncoder, GipfCapture.listEncoder], (move) => [move.placement, move.initialCaptures, move.finalCaptures], (fields) => new GipfMove(fields[0], fields[1], fields[2]));
    constructor(placement, initialCaptures, finalCaptures) {
        super();
        this.placement = placement;
        this.initialCaptures = initialCaptures;
        this.finalCaptures = finalCaptures;
    }
    toString() {
        return 'GipfMove([' +
            this.capturesToString(this.initialCaptures) + '], ' +
            this.placement.toString() + ', [' +
            this.capturesToString(this.finalCaptures) + '])';
    }
    capturesToString(captures) {
        let str = '';
        for (const capture of captures) {
            if (str !== '') {
                str += ',';
            }
            str += '[' + capture.toString() + ']';
        }
        return str;
    }
    equals(other) {
        if (this === other)
            return true;
        if (this.placement.equals(other.placement) === false)
            return false;
        if (ArrayUtils.equals(this.initialCaptures, other.initialCaptures) === false)
            return false;
        if (ArrayUtils.equals(this.finalCaptures, other.finalCaptures) === false)
            return false;
        return true;
    }
}
